export default __webpack_public_path__ + "images/7431e6b3a27fc6c00b385e4d68c6ef4a.svg";